const baseStyle = () => {
  return {
    alignItems: 'flex-start',
    mx: 'auto',
    maxWidth: '100%',
    px: '4',
    width: '100%',
    _text: { textAlign: 'inherit' },
  };
};

export default {
  baseStyle,
};
